<template>
  <Modal :value="modalManifestedXmlsIsOpen" :onClose="cancel" class="importationModal" size="large">
    <b-container>
      <p>
        Listando os últimos 50 manifestos de "Confirmação da operação", exibindo apenas os que ainda
        não foram importados para as Compras
      </p>
      <p>
        Para importar um manifesto, clique sobre o manifesto desejado e depois em Importar
      </p>

      <div class="wrapper">
        <table class="manifestos">
          <thead>
            <tr>
              <th>Número</th>
              <th>Chave</th>
              <th>Fornecedor</th>
              <th>Valor</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(manifesto, i) in manifestos"
              :key="i"
              :class="{ selected: selected.id === manifesto.id }"
              @click="(event) => onSelectManifesto(manifesto, event)"
            >
              <td>{{ manifesto.numero }}</td>
              <td>{{ manifesto.chave }}</td>
              <td>{{ manifesto.fornecedor }}</td>
              <td>{{ manifesto.valorTotal }}</td>
            </tr>
            <tr v-if="!loading && !manifestos.length">
              <td colspan="4">
                Nenhum Manifesto encontrado
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-container>

    <b-row class="margin-button-save" align="center">
      <b-col>
        <Button type="cancel" @click="cancel">
          <Close :disabled="loading" class="mb-1" title="Cancelar" /> Cancelar
        </Button>
        <Button type="success" @click="onConfirm" :disabled="!selected.id || loading"
          >Importar</Button
        >
      </b-col>
    </b-row>
  </Modal>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Close from 'vue-material-design-icons/Close';
import { Modal, Button } from '@/components';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';

export default {
  name: 'ModalManifestedXmls',
  mixins: [FormatMixin],
  components: {
    Modal,
    Button,
    Close,
  },
  props: {
    confirm: {
      type: Function,
    },
  },
  data: () => ({
    loading: true,
    manifestos: [],
    selected: {},
  }),
  async mounted() {
    try {
      this.loading = true;
      const manifestos = await this.getPendingManifestos();
      this.manifestos = manifestos.map((manifesto) => {
        const valorTotal = new Intl.NumberFormat('pt-BR', {
          style: 'decimal',
          minimumFractionDigits: 2,
        }).format(manifesto.valorTotal);

        return { ...manifesto, valorTotal };
      });
    } finally {
      this.loading = false;
    }
  },
  computed: {
    ...mapState('componentsPurchase', ['modalManifestedXmlsIsOpen']),
  },
  methods: {
    ...mapActions('componentsPurchase', ['toggleModalManifestedXmls']),
    ...mapActions('purchase', ['getPendingManifestos']),
    async onConfirm() {
      if (this.loading) return;

      try {
        this.loading = true;
        await this.confirm(this.selected);
      } finally {
        this.loading = false;
      }
    },
    onSelectManifesto(manifesto) {
      if (this.loading) return;
      this.selected = { ...manifesto };
    },
    async cancel() {
      await this.toggleModalManifestedXmls();
    },
  },
};
</script>

<style scoped lang="scss">
div.wrapper {
  height: 70vh;
  overflow-y: auto;
  border: thin solid #dadada;

  table.manifestos {
    thead tr,
    tbody tr:not(:last-child) {
      border-bottom: thin solid #dadada;
    }

    thead {
      position: sticky;
      top: 0;
    }

    td,
    th {
      border-right: thin solid #dadada;
      padding: 4px;
    }

    tbody tr {
      cursor: pointer;

      &:hover,
      &.selected {
        background-color: #d3d3d3;
      }
    }
  }
}
</style>
